// "Por qué llegó a este monto": lo que aportó cada regla, umbral y ajuste, con su peso.
// Mockup: surekeep/mockups/backoffice/portal-admin-vl-com-pagadas.html
import { cn } from '@/lib/cn';
import { formatMoneyCents } from '@/shared/lib/format/money';
import type { WhyItem } from '../../lib/sellerWeek';

const BAR_CLASS: Record<WhyItem['tone'], string> = {
    rule: 'bg-primary',
    threshold: 'bg-info',
    rent: 'bg-success',
    adjustment: 'bg-warning',
    clawback: 'bg-destructive',
};

export function WhyList({ items }: { items: readonly WhyItem[] }) {
    if (items.length === 0)
        return (
            <p className="text-[11px] text-muted-foreground">Sin reglas activadas en este corte</p>
        );
    const positive = items.reduce((sum, item) => sum + Math.max(item.amountCents, 0), 0);
    const max = Math.max(...items.map((item) => Math.abs(item.amountCents)));
    return (
        <ul className="flex flex-col gap-2" aria-label="Por qué llegó a este monto">
            {items.map((item) => (
                <li key={item.key} className="text-[11px]">
                    <div className="flex items-baseline justify-between gap-2">
                        <span className="min-w-0 truncate font-medium">{item.label}</span>
                        <span
                            className={cn(
                                'tabular-nums',
                                item.amountCents < 0 ? 'text-destructive' : 'font-semibold',
                            )}
                        >
                            {item.amountCents < 0
                                ? `− ${formatMoneyCents(-item.amountCents)}`
                                : formatMoneyCents(item.amountCents)}
                            {item.amountCents > 0 && positive > 0 && (
                                <span className="ml-1 text-[10px] font-normal text-muted-foreground">
                                    {Math.round((item.amountCents / positive) * 100)}%
                                </span>
                            )}
                        </span>
                    </div>
                    <div className="mt-0.5 h-1.5 rounded bg-muted">
                        <div
                            className={cn('h-full rounded', BAR_CLASS[item.tone])}
                            style={{
                                width: `${String(max > 0 ? (Math.abs(item.amountCents) / max) * 100 : 0)}%`,
                            }}
                        />
                    </div>
                    <p className="mt-0.5 text-[10px] text-muted-foreground">{item.detail}</p>
                </li>
            ))}
        </ul>
    );
}
